import type { NotificationStackItemMap, INotificationStackItem } from '../model/notificationTypes';
import { vueSet,  vueDelete, reactive } from '@mimir/web/compat/vueCompat';


export const notifications: NotificationStackItemMap = reactive({});


export function addNotification(notification: INotificationStackItem) {
  vueSet(notifications, notification.key, notification);
}


export function deleteNotification(notification: INotificationStackItem) {
  vueDelete(notifications, notification.key);
}


export function updateNotification(notification: INotificationStackItem) {
  if (notifications[notification.key]) {
    notifications[notification.key] = notification;
  }
}
